// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const green = "RateComparison__green__nzYoO";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const median = "RateComparison__median__3heUp";
export const medium = "500";
export const rateComparison = "RateComparison__rateComparison__ywGjD";
export const rateComparisonWrapper = "RateComparison__rateComparisonWrapper__8rup2";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const totalMax = "RateComparison__totalMax__Y82bj";
export const totalMin = "RateComparison__totalMin__vLXZs";
export const userRate = "RateComparison__userRate__65Q+1";
export const userRateTooltip = "RateComparison__userRateTooltip__Py2VL";